import { useContext } from 'react'
import { SidebarContext } from '../../../shared/contexts/SidebarContext'
import HeaderButtons from './Buttons'
import HeaderUserbox from './Userbox'
import { NavbarWrapper, NavbarLeft, NavbarRight, HamburgerButton, CollapseButton } from './Header.styled'

const MenuIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </svg>
)

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
)

function Header() {
  const { sidebarToggle, toggleSidebar, toggleCollapse } = useContext(SidebarContext)

  return (
    <NavbarWrapper $sidebarWidth="0">
      <NavbarLeft>
        <CollapseButton onClick={toggleCollapse} title="Toggle sidebar">
          <MenuIcon />
        </CollapseButton>
        <HamburgerButton onClick={toggleSidebar} title="Toggle menu">
          {sidebarToggle ? <CloseIcon /> : <MenuIcon />}
        </HamburgerButton>
      </NavbarLeft>
      <NavbarRight>
        <HeaderButtons />
        <HeaderUserbox />
      </NavbarRight>
    </NavbarWrapper>
  )
}

export default Header
